// Passion Program (/passion) — сурагч өөрөө; эцэг эх ?s=<хүүхдийн id>. Мэдэгдлээс энд үсэрнэ. ?p=<id> — тэр хөтөлбөрийг нээнэ.
// Урсгал (2026-10-30): карт → постер (дэлгэрэнгүй) → Бүртгүүлэх → нэр, ID (автомат), журамтай танилцаж зөвшөөрөх, гарын үсэг → "Бүртгэлийг хүлээн авлаа"
// → нүүрэнд "баталгаажуулалт хүлээж буй". Хөтөлбөр хэрэгжихээр шийдэгдвэл барьцаа төлж баталгаажуулна (дараагийн шат).
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Checkbox, Modal, Spin, message } from "antd";
import { FiArrowLeft, FiCheckCircle, FiX } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";
import Poster, { MiniPoster, WeekPoster } from "./Poster";
import SignaturePad from "./SignaturePad";

export const CHOICE = {
  pending: ["Баталгаажуулалт хүлээж буй", "bg-[#fffbeb] text-[#92400e]"],
  seated: ["Суудал авсан", "bg-[#dcfce7] text-[#166534]"], confirmed: ["Баталгаажсан", "bg-[#dcfce7] text-[#166534]"],
  waitlist: ["Хүлээлэгт", "bg-[#fffbeb] text-[#92400e]"], interest: ["Сонирхол бүртгэсэн", "bg-[#f3eeff] text-[#5c1090]"],
};
// Бүртгэлийн хязгаар (ээлж бүр capacity, ээлжгүй бол хөтөлбөрийн limit): { n, cap, full }
export const fill = (p, s) => {
  const cap = s ? s.capacity : p.limit;
  const n = s ? s.registered || 0 : p.counts?.registered || 0;
  return { n, cap, full: cap != null && n >= cap };
};
const isFull = (p) => (p.sessions.length ? p.sessions.every((s) => fill(p, s).full) : fill(p, null).full);
const when = (d) => (d ? dayjs(d).format("MM/DD HH:mm") : "");
const money = (n) => (n ? `${Number(n).toLocaleString()}₮` : "");

function Rules({ d }) {
  const r = d.round;
  if (!r) return <section className="tj-card p-5 text-sm text-[#6e5e8a]">Бүртгэл хараахан зарлагдаагүй байна. Нээгдэхэд мэдэгдэл ирнэ.</section>;
  const head = { soon: `Бүртгэл ${when(r.opensAt)}-д нээгдэнэ`, first: `Бүртгэл нээлттэй · ${when(r.closesAt)} хүртэл`, second: `Бүртгэл нээлттэй · ${when(r.closesAt)} хүртэл`, closed: "Бүртгэл хаагдсан" }[d.phase];
  return (
    <section className="rounded-2xl bg-[#faf7ff] border border-[#e5d8f5] p-4 flex flex-col gap-1.5 text-[13px] leading-relaxed">
      <b className="text-primary text-sm">{head}</b>
      <span>• Сонирхсон хөтөлбөр дээрээ дарж танилцаад «Бүртгүүлэх»-ийг дарна.</span>
      {d.phase === "first" && r.secondPickAt ? <span>• Одоо 1 хөтөлбөрт бүртгүүлнэ. {when(r.secondPickAt)}-аас хойш {r.maxPicks} хүртэл болно.</span>
        : <span>• {r.maxPicks} хүртэл хөтөлбөрт бүртгүүлнэ.</span>}
      <span>• Хөтөлбөр (бүлэг) бүрт 20 хүртэл сурагч бүртгүүлнэ. Дүүрвэл бүртгэл хаагдана.</span>
      <span>• Хөтөлбөрт хамрагдах сурагчийн тоо бүрдвэл барьцаа төлбөр байршуулах мэдэгдэл очно. Барьцаагаа төлснөөр бүртгэл баталгаажна.</span>
    </section>
  );
}

const Tag = ({ c, className = "" }) => {
  const t = CHOICE[c?.status];
  return t ? <span className={`text-[10px] font-bold rounded-full px-2 py-0.5 ${t[1]} ${className}`}>{t[0]}</span> : null;
};

// Постерын доорх хэсэг: миний төлөв / ээлж сонгох / Бүртгүүлэх
function Actions({ p, d, busy, onRegister, onCancel }) {
  const open = ["first", "second"].includes(d.phase);
  const full = d.picked >= d.limit;
  const deposit = p.priceType === "deposit" ? `Барьцаа ${money(p.deposit)} · ирц 80%-иас дээш бол буцаан олгоно` : p.priceType === "paid" ? `Төлбөр ${money(p.price)} / улирал` : "Үнэгүй";
  if (p.status === "intro") return <div className="text-sm text-[#6e5e8a]">Танилцуулга · бүртгэл нээгдэхэд бүртгүүлнэ.</div>;
  if (p.status === "interest") {
    return (
      <div className="flex items-center gap-3">
        <span className="flex-1 text-[13px] text-[#6e5e8a]">{p.interestCount ? `${p.interestCount} хүүхэд сонирхсон` : "Анхны сонирхогч болоорой"}</span>
        {p.mine ? <button type="button" disabled={busy} onClick={onCancel} className="pchip pchip-off">Болих</button>
          : open && <button type="button" disabled={busy} onClick={() => onRegister(null)} className="pchip pchip-off !text-primary !border-primary">Сонирхол бүртгэх</button>}
      </div>
    );
  }
  if (p.mine) {
    const s = p.sessions.find((x) => x.id === p.mine.sessionId);
    return (
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 flex-wrap">
          <Tag c={p.mine} className="!text-xs" />
          {s && <span className="text-[13px] text-[#6e5e8a]">{s.label}</span>}
        </div>
        {p.mine.status === "pending" && <p className="m-0 text-[13px] text-gray-600 leading-relaxed">Бүртгэлийг хүлээн авлаа. Хөтөлбөрт хамрагдах сурагчийн тоо бүрдсэн тохиолдолд барьцаа төлбөр байршуулах мэдэгдэл очно.</p>}
        {["pending", "seated", "waitlist"].includes(p.mine.status) && open && (
          <button type="button" disabled={busy} onClick={onCancel} className="pchip pchip-off self-start">Бүртгэл цуцлах</button>
        )}
      </div>
    );
  }
  if (!open) return <div className="text-sm text-[#6e5e8a]">{d.phase === "soon" ? `Бүртгэл ${when(d.round?.opensAt)}-д нээгдэнэ.` : "Бүртгэл хаагдсан."}</div>;
  return (
    <div className="flex flex-col gap-2">
      <div className="text-[13px] text-gray-600">{deposit}</div>
      {full ? <div className="text-sm text-[#6e5e8a]">{d.limit} хөтөлбөрт бүртгүүлсэн байна.</div>
        : p.sessions.length > 1 ? (
          <div className="flex flex-col gap-2">
            {p.sessions.map((s) => {
              const f = fill(p, s);
              return (
                <div key={s.id} className={`flex items-center gap-3 rounded-xl border border-[#f0edf5] p-2.5 ${f.full ? "bg-gray-50" : ""}`}>
                  <span className="flex-1 text-[13px]"><b>{s.label}</b>{s.days ? ` · ${s.days} ${s.time}` : ""}
                    {f.cap != null && <span className={`block text-xs ${f.full ? "text-[#b91c1c] font-semibold" : "text-[#6e5e8a]"}`}>{f.full ? "Бүртгэл дүүрсэн" : `${f.n}/${f.cap} бүртгүүлсэн`}</span>}
                  </span>
                  {f.full ? <span className="pchip pchip-dis">Дүүрсэн</span>
                    : <button type="button" disabled={busy} onClick={() => onRegister(s)} className="pchip pchip-on">Бүртгүүлэх</button>}
                </div>
              );
            })}
          </div>
        ) : (() => {
          const s = p.sessions[0] || null;
          const f = fill(p, s);
          return (
            <>
              {f.cap != null && <div className={`text-[13px] ${f.full ? "text-[#b91c1c] font-semibold" : "text-[#6e5e8a]"}`}>{f.full ? `Бүртгэл дүүрсэн (${f.n}/${f.cap})` : `${f.n}/${f.cap} бүртгүүлсэн · ${f.cap - f.n} суудал үлдсэн`}</div>}
              {f.full ? <div className="h-12 rounded-full bg-gray-100 text-gray-400 font-bold text-[15px] flex items-center justify-center">Бүртгэл дүүрсэн</div>
                : <button type="button" disabled={busy} onClick={() => onRegister(s)} className="h-12 rounded-full bg-primary text-white font-bold text-[15px] cursor-pointer">Бүртгүүлэх</button>}
            </>
          );
        })()}
    </div>
  );
}

// Бүртгэлийн маягт: нэр, ID (портал мэднэ), журам → зөвшөөрөх → гарын үсэг (base64 PNG хадгална)
function Register({ p, s, d, who, busy, onSubmit, onBack }) {
  const [sig, setSig] = useState(null);
  const [agree, setAgree] = useState(false);
  const ok = agree && !!sig;
  const st = d.student;
  return (
    <div className="flex flex-col gap-3 p-5">
      <div>
        <div className="text-[11px] font-bold tracking-[0.12em] uppercase text-primary">Бүртгэл</div>
        <h2 className="m-0 text-[20px] font-extrabold text-primary leading-snug">{p.name}{s && p.sessions.length > 1 ? ` · ${s.label}` : ""}</h2>
      </div>
      <div className="flex items-center gap-3 rounded-xl bg-[#faf7ff] border border-[#e5d8f5] px-3 py-2.5">
        <span className="flex-1 min-w-0">
          <span className="block text-[11px] font-semibold text-[#6e5e8a]">Сурагч</span>
          <span className="block text-[15px] font-bold truncate">{[st.lastName, st.firstName].filter(Boolean).join(" ")}</span>
        </span>
        <span className="text-right shrink-0">
          <span className="block text-[11px] font-semibold text-[#6e5e8a]">ID</span>
          <span className="block text-[15px] font-bold tabular-nums">{st.code}</span>
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-[13px] font-semibold">Хөтөлбөрийн журам</span>
        <div className="max-h-[38vh] overflow-y-auto rounded-xl border border-[#e5d8f5] bg-[#faf7ff] p-3 text-[12.5px] leading-relaxed whitespace-pre-line">{d.round?.terms}</div>
      </div>
      <Checkbox checked={agree} onChange={(e) => setAgree(e.target.checked)}><span className="text-[13px]">Журамтай танилцаж, дагаж мөрдөхөө зөвшөөрч байна</span></Checkbox>
      <div className="flex flex-col gap-1">
        <span className="text-[13px] font-semibold">{who === "me" ? "Гарын үсэг" : "Эцэг эх / асран хамгаалагчийн гарын үсэг"}</span>
        <SignaturePad onChange={setSig} />
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={onBack} className="pchip pchip-off h-12 flex-1">Буцах</button>
        <button type="button" disabled={busy || !ok} onClick={() => onSubmit(sig)}
          className={`h-12 flex-[2] rounded-full font-bold text-[15px] ${ok ? "bg-primary text-white cursor-pointer" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`}>Бүртгүүлэх</button>
      </div>
    </div>
  );
}

function Done({ p, onClose }) {
  return (
    <div className="flex flex-col items-center text-center gap-3 p-6">
      <FiCheckCircle className="text-[#16a34a]" size={52} />
      <h2 className="m-0 text-[20px] font-extrabold text-primary">Бүртгэлийг хүлээн авлаа</h2>
      <p className="m-0 text-[14px] text-gray-600 leading-relaxed"><b>{p.name}</b> хөтөлбөрт хамрагдах сурагчийн тоо бүрдсэн тохиолдолд барьцаа төлбөр байршуулах мэдэгдэл очно.</p>
      <p className="m-0 text-[13px] text-[#6e5e8a]">Нүүр хуудсанд «Баталгаажуулалт хүлээж буй» хэсэгт харагдана.</p>
      <button type="button" onClick={onClose} className="h-11 px-8 rounded-full bg-primary text-white font-bold cursor-pointer">Ойлголоо</button>
    </div>
  );
}

export default function Passion() {
  const [params, setParams] = useSearchParams();
  const who = params.get("s") || "me";
  const [d, setD] = useState(null);
  const [openId, setOpenId] = useState(params.get("p") ? Number(params.get("p")) : null);
  const [step, setStep] = useState(null); // null · { s } (маягт) · "done"
  const [busy, setBusy] = useState(false);
  const load = () => instance({ method: "get", url: `/student/passion/${who}`, silent: true }).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  useEffect(() => { setD(null); load(); }, [who]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!d) return <div className="flex justify-center py-16"><Spin /></div>;
  if (d.error) return <div className="pt-8 max-w-3xl mx-auto text-sm text-gray-500">Мэдээлэл татаж чадсангүй.</div>;
  const list = [...d.programs].sort((a, b) => !!b.mine - !!a.mine);
  const sel = d.programs.find((p) => p.id === openId);
  const close = () => { setOpenId(null); setStep(null); if (params.get("p")) { params.delete("p"); setParams(params, { replace: true }); } };
  const err = (e) => message.error(e?.response?.data?.message || e?.response?.data?.error || "Алдаа гарлаа");

  const register = (p, s, signature) => {
    setBusy(true);
    instance({ method: "post", url: `/student/passion/${who}/choose`, data: { programId: p.id, sessionId: s?.id, termsAccepted: true, signature }, silent: true })
      .then((r) => { if (r.data?.status === "interest") { message.success("Сонирхол бүртгэлээ"); setStep(null); } else setStep("done"); load(); })
      .catch(err).finally(() => setBusy(false));
  };
  const cancel = (p) => {
    const run = () => {
      setBusy(true);
      return instance({ method: "post", url: `/student/passion/${who}/cancel`, data: { choiceId: p.mine.id }, silent: true })
        .then(() => { message.success("Цуцаллаа"); load(); }).catch(err).finally(() => setBusy(false));
    };
    if (p.mine.status === "interest") run();
    else Modal.confirm({ title: `${p.name} — бүртгэлээ цуцлах уу?`, okText: "Цуцлах", cancelText: "Болих", onOk: run });
  };

  return (
    <div className="pt-4 md:pt-8 pb-8 max-w-3xl mx-auto w-full flex flex-col gap-4">
      <Link to={who === "me" ? "/growth" : `/child?c=${who}`} className="self-start text-sm flex items-center gap-1"><FiArrowLeft /> {who === "me" ? "Хөгжил" : "Хүүхэд"}</Link>
      <div>
        <h1 className="m-0 text-[26px] md:text-[32px] font-extrabold text-primary leading-tight">Passion Program</h1>
        <p className="m-0 mt-1 text-sm text-[#6e5e8a]">{d.round?.name || ""}{who !== "me" ? ` · ${d.student.firstName}` : ""}{d.round && d.limit ? ` · ${d.picked}/${d.limit} бүртгүүлсэн` : ""}</p>
      </div>
      <Rules d={d} />
      {list.length > 0 && (
        <section className="flex flex-col gap-2">
          <h2 className="m-0 text-base font-bold">Долоо хоногийн хуваарь</h2>
          <div className="rounded-[14px] overflow-hidden border border-[#e9e8f0]"><WeekPoster programs={list} onOpen={(p) => { setOpenId(p.id); setStep(null); }} /></div>
        </section>
      )}
      {!list.length ? <section className="tj-card p-6 text-sm text-[#6e5e8a] text-center">Таны ангид нээлттэй хөтөлбөр алга.</section>
        : <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {list.map((p) => <MiniPoster key={p.id} p={p} onClick={() => { setOpenId(p.id); setStep(null); }} tag={p.mine ? <Tag c={p.mine} className="absolute top-2 right-2 shadow" />
            : p.status === "active" && isFull(p) ? <span className="absolute top-2 right-2 text-[10px] font-bold rounded-full px-2 py-0.5 bg-white text-[#b91c1c] shadow">Дүүрсэн</span> : null} />)}
        </div>}
      <Modal open={!!sel} onCancel={close} footer={null} centered width={560} destroyOnClose closeIcon={null}
        styles={{ content: { padding: 0, overflow: "hidden", borderRadius: 18 } }}>
        {sel && (
          <div className="relative">
            {step && <button type="button" onClick={close} aria-label="Хаах" className="absolute z-10 top-3 right-3 w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center cursor-pointer"><FiX /></button>}
            {step === "done" ? <Done p={sel} onClose={close} />
              : step ? <Register p={sel} s={step.s} d={d} who={who} busy={busy} onBack={() => setStep(null)} onSubmit={(code) => register(sel, step.s, code)} />
                : (
                  <>
                    <Poster p={sel} />
                    <div className="p-4 md:p-5 flex flex-col gap-3">
                      <Actions p={sel} d={d} busy={busy} onRegister={(s) => (sel.status === "interest" ? register(sel, null) : setStep({ s }))} onCancel={() => cancel(sel)} />
                      <button type="button" onClick={close} className="self-center text-sm text-[#6e5e8a] cursor-pointer bg-transparent border-0">Хаах</button>
                    </div>
                  </>
                )}
          </div>
        )}
      </Modal>
    </div>
  );
}
